// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__9YEYV","overlay":"Modal_overlay__XkXR2","content":"Modal_content__KDPPi","opened":"Modal_opened__7r3D7"};